import { useMemo } from "react";
import { useIntl } from "react-intl";
export var useCoEditionRequestTable = function (onRowClick) {
    var _a = useIntl(), formatMessage = _a.formatMessage, formatDate = _a.formatDate;
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.co-edition.list.column.dateCreated",
            }),
            key: "dateCreated",
            cellRenderer: function (item) {
                return item.dateCreated ? formatDate(item.dateCreated) : "N/A";
            },
            clickable: true,
            onClick: onRowClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.co-edition.list.column.title",
            }),
            key: "product",
            id: "title",
            cellRenderer: function (item) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = item.product) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.names) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "N/A"; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.co-edition.list.column.coPublisher",
            }),
            key: "coPublisher",
            cellRenderer: function (item) { var _a, _b; return (_b = (_a = item.coPublisher) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "N/A"; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.co-edition.list.column.status",
            }),
            key: "status",
            cellRenderer: function (item) {
                return item.status
                    ? formatMessage({
                        id: "ui-br-agency.co-edition.status.".concat(item.status),
                    })
                    : "N/A";
            },
        },
        {
            name: formatMessage({ id: "ui-br-agency.co-edition.list.column.note" }),
            key: "note",
            cellRenderer: function (item) { var _a; return (_a = item.note) !== null && _a !== void 0 ? _a : "N/A"; },
        },
    ]; }, [formatMessage, formatDate, onRowClick]);
    return { columns: columns };
};
